import qs from "qs";

export const DEFAULT_THEME_SLUG = "geniusfeed";

export const sanitizeCustomer = (value: string) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9-_]/g, "")
    .trim();

export const getQueryCustomer = (): string => {
  const params = qs.parse(window.location.search.slice(1));
  const rawValue = params.customer;
  if (typeof rawValue === "string") {
    return rawValue;
  }
  if (Array.isArray(rawValue) && rawValue.length) {
    const candidate = rawValue[0];
    return typeof candidate === "string" ? candidate : "";
  }
  return "";
};

export const loadLocalThemes = (): Record<string, Record<string, unknown>> => {
  if (typeof require === "undefined") {
    return {};
  }
  try {
    // @ts-expect-error - webpack injects require.context
    const context = require.context("../../config/themes", false, /\.json$/);
    return context
      .keys()
      .reduce<Record<string, Record<string, unknown>>>(
        (acc: Record<string, Record<string, unknown>>, key: string) => {
          const normalizedKey = key
            .replace(/^\.\//, "")
            .replace(/\.json$/i, "");
          acc[normalizedKey] = context(key) as Record<string, unknown>;
          return acc;
        },
        {} as Record<string, Record<string, unknown>>
      );
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn("[theme-setter] Unable to load local templates", error);
    }
    return {};
  }
};

export const cloneDeep = <T,>(value: T): T => JSON.parse(JSON.stringify(value));
